// class UserModel {
// 	String id;
// 	DateTime createAt;
// 	DateTime? recentLoginAt;
// 	DateTime? hasSeenNotificationAt;
// 	DateTime? hasSeenNoticeAt;
// 	String? recentLoginVersion;
// 	String? authId;
// 	bool isAdditionalInfoComplete;
// 	String? email;
// 	String? socialUid;
// 	String? accountId;
// 	String? name;
// 	String? nickname;
// 	DateTime? birth;
// 	String? profileImageUrl;
// 	String? profileImageBlurHash;
// 	UserType? userType;
// 	MembershipType? membershipType;
// 	SignUpMethod? signUpMethod;
// 	int? point;
// 	String? myInvitationLink;
// 	bool? allowMarketing;
// 	String? pushToken;
// 	Map<dynamic, dynamic> unreadChatCountByRoomId;
// 	List<dynamic> blockIds;
// 	List<dynamic> reportPostIds;
// 	List<dynamic> reportCommentIds;
// 	List<dynamic> myNotiKeywordList;
// 	List<dynamic> myChatRoomList;
// 	List<dynamic> pushTopicList;
// 	Gender? gender;
// 	String? phone;
// 	bool allowActivityNotification;
// 	bool allowChatNotification;
// 	bool isAdmin;
// 	AdminRole? adminRole;
// 	String? userRoleId;
// 	String? coment;
// 	String? adminMemo;
// 	List<dynamic> areas;
// 	List<dynamic> likeFindTechnicianIds;
// 	List<dynamic> likeRequsetWorkIds;
// 	List<dynamic> likeJobPostingTraineeIds;
// 	List<dynamic> likeJobPostingIds;
// 	bool isChangeNickName;
// 	String? subscriptionId;
// 	DateTime? subscriptionEndAt;
// 	bool? iosSubscription;
// 	bool? allowJobOffer;
// 	bool? allowRequestWork;
// 	bool? allowReceiveWork;
// 	bool? allowapplyWork;
// 	bool? allowJobPosting;
// 	bool? allowinterview;
// 	bool? allowAskAnswer;
// 	bool? allowMarket;
// 	bool? allowCompanyNews;
// 	bool? allowWirePrice;
// 	bool? quit;
// 	String? quitPhone;
// 	String? quitEmail;
// 	DateTime? quitAt;
// 	bool? isSubscribeFree;
// 	bool? isAdminSetSubscribeFree;
// 	bool? showEndContentReqWork;
// 	bool? showEndContentFindTech;
// 	bool? showEndContentJobPosting;
// 	bool? showEndContentMarket;
// 	bool? showEndContentCompanyNews;
// 	SubscriptionType? subscriptionType;
// 	bool? subscriptionRemainingDays;
// 	String? recommenderNumber;
// 	bool? isFreeSubscribe;
// 	DateTime? freeSubscribeStartAt;
// 	String? languageCode;
// 	bool isBanned;
// 	int unreadCommunityCommentCount;
// 	Map<String, dynamic> qnaUnreadComments;
// 	String? lastSeenWirePriceId;
// 	String? country;
// 	String? lastCountry;
// 	bool? showHomeBottomHint;
// 	String? signUpPlatform;
// 	String? recentLoginPlatform;
// }

import ModelCommon from "./ModelCommon";
import "firebase/compat/firestore";
import firebase from "firebase/compat/app";

class UserModel {
	constructor(json) {
		this.id = ModelCommon.toText(json.id, true);
		this.createAt = ModelCommon.toTimestamp(json.createAt);
		this.recentLoginAt = ModelCommon.toTimestamp(json.recentLoginAt);
		this.hasSeenNotificationAt = ModelCommon.toTimestamp(json.hasSeenNotificationAt);
		this.hasSeenNoticeAt = ModelCommon.toTimestamp(json.hasSeenNoticeAt);
		this.recentLoginVersion = ModelCommon.toText(json.recentLoginVersion, false);
		this.authId = ModelCommon.toText(json.authId, false);
		this.isAdditionalInfoComplete = ModelCommon.toSafeValue(json.isAdditionalInfoComplete);
		this.email = ModelCommon.toText(json.email, false);
		this.socialUid = ModelCommon.toText(json.socialUid, false);
		this.accountId = ModelCommon.toText(json.accountId, false);
		this.name = ModelCommon.toText(json.name, false);
		this.nickname = ModelCommon.toText(json.nickname, false);
		this.birth = ModelCommon.toTimestamp(json.birth);
		this.profileImageUrl = ModelCommon.toText(json.profileImageUrl, false);
		this.profileImageBlurHash = ModelCommon.toText(json.profileImageBlurHash, false);
		this.userType = ModelCommon.toSafeValue(json.userType);
		this.membershipType = ModelCommon.toSafeValue(json.membershipType);
		this.signUpMethod = ModelCommon.toSafeValue(json.signUpMethod);
		this.point = ModelCommon.toNumber(json.point, false);
		this.myInvitationLink = ModelCommon.toText(json.myInvitationLink, false);
		this.allowMarketing = ModelCommon.toSafeValue(json.allowMarketing);
		this.pushToken = ModelCommon.toText(json.pushToken, false);
		this.unreadChatCountByRoomId = ModelCommon.toMap(json.unreadChatCountByRoomId, true);
		this.blockIds = ModelCommon.toList(json.blockIds, true);
		this.reportPostIds = ModelCommon.toList(json.reportPostIds, true);
		this.reportCommentIds = ModelCommon.toList(json.reportCommentIds, true);
		this.myNotiKeywordList = ModelCommon.toList(json.myNotiKeywordList, true);
		this.myChatRoomList = ModelCommon.toList(json.myChatRoomList, true);
		this.pushTopicList = ModelCommon.toList(json.pushTopicList, true);
		this.gender = ModelCommon.toSafeValue(json.gender);
		this.phone = ModelCommon.toText(json.phone, false);
		this.allowActivityNotification = ModelCommon.toSafeValue(json.allowActivityNotification);
		this.allowChatNotification = ModelCommon.toSafeValue(json.allowChatNotification);
		this.isAdmin = ModelCommon.toSafeValue(json.isAdmin);
		this.adminRole = ModelCommon.toSafeValue(json.adminRole);
		this.userRoleId = ModelCommon.toText(json.userRoleId, false);
		this.coment = ModelCommon.toText(json.coment, false);
		this.adminMemo = ModelCommon.toText(json.adminMemo, false);
		this.areas = ModelCommon.toList(json.areas, true);
		this.likeFindTechnicianIds = ModelCommon.toList(json.likeFindTechnicianIds, true);
		this.likeRequsetWorkIds = ModelCommon.toList(json.likeRequsetWorkIds, true);
		this.likeJobPostingTraineeIds = ModelCommon.toList(json.likeJobPostingTraineeIds, true);
		this.likeJobPostingIds = ModelCommon.toList(json.likeJobPostingIds, true);
		this.isChangeNickName = ModelCommon.toSafeValue(json.isChangeNickName);
		this.subscriptionId = ModelCommon.toText(json.subscriptionId, false);
		this.subscriptionEndAt = ModelCommon.toTimestamp(json.subscriptionEndAt);
		this.iosSubscription = ModelCommon.toSafeValue(json.iosSubscription);
		this.allowJobOffer = ModelCommon.toSafeValue(json.allowJobOffer);
		this.allowRequestWork = ModelCommon.toSafeValue(json.allowRequestWork);
		this.allowReceiveWork = ModelCommon.toSafeValue(json.allowReceiveWork);
		this.allowapplyWork = ModelCommon.toSafeValue(json.allowapplyWork);
		this.allowJobPosting = ModelCommon.toSafeValue(json.allowJobPosting);
		this.allowinterview = ModelCommon.toSafeValue(json.allowinterview);
		this.allowAskAnswer = ModelCommon.toSafeValue(json.allowAskAnswer);
		this.allowMarket = ModelCommon.toSafeValue(json.allowMarket);
		this.allowCompanyNews = ModelCommon.toSafeValue(json.allowCompanyNews);
		this.allowWirePrice = ModelCommon.toSafeValue(json.allowWirePrice);
		this.quit = ModelCommon.toSafeValue(json.quit);
		this.quitPhone = ModelCommon.toText(json.quitPhone, false);
		this.quitEmail = ModelCommon.toText(json.quitEmail, false);
		this.quitAt = ModelCommon.toTimestamp(json.quitAt);
		this.isSubscribeFree = ModelCommon.toSafeValue(json.isSubscribeFree);
		this.isAdminSetSubscribeFree = ModelCommon.toSafeValue(json.isAdminSetSubscribeFree);
		this.showEndContentReqWork = ModelCommon.toSafeValue(json.showEndContentReqWork);
		this.showEndContentFindTech = ModelCommon.toSafeValue(json.showEndContentFindTech);
		this.showEndContentJobPosting = ModelCommon.toSafeValue(json.showEndContentJobPosting);
		this.showEndContentMarket = ModelCommon.toSafeValue(json.showEndContentMarket);
		this.showEndContentCompanyNews = ModelCommon.toSafeValue(json.showEndContentCompanyNews);
		this.subscriptionType = ModelCommon.toSafeValue(json.subscriptionType);
		this.subscriptionRemainingDays = ModelCommon.toSafeValue(json.subscriptionRemainingDays);
		this.recommenderNumber = ModelCommon.toText(json.recommenderNumber, false);
		this.isFreeSubscribe = ModelCommon.toSafeValue(json.isFreeSubscribe);
		this.freeSubscribeStartAt = ModelCommon.toTimestamp(json.freeSubscribeStartAt);
		this.languageCode = ModelCommon.toText(json.languageCode, false);
		this.isBanned = ModelCommon.toSafeValue(json.isBanned);
		this.unreadCommunityCommentCount = ModelCommon.toNumber(json.unreadCommunityCommentCount, true);
		this.qnaUnreadComments = ModelCommon.toMap(json.qnaUnreadComments, true);
		this.lastSeenWirePriceId = ModelCommon.toText(json.lastSeenWirePriceId, false);
		this.country = ModelCommon.toText(json.country, false);
		this.lastCountry = ModelCommon.toText(json.lastCountry, false);
		this.showHomeBottomHint = ModelCommon.toSafeValue(json.showHomeBottomHint);
		this.signUpPlatform = ModelCommon.toText(json.signUpPlatform, false);
		this.recentLoginPlatform = ModelCommon.toText(json.recentLoginPlatform, false);
	}

	setId(value) {
		this.id = ModelCommon.toText(value, true);
	}

	setCreateAt(value) {
		this.createAt = ModelCommon.toTimestamp(value);
	}

	setRecentLoginAt(value) {
		this.recentLoginAt = ModelCommon.toTimestamp(value);
	}

	setHasSeenNotificationAt(value) {
		this.hasSeenNotificationAt = ModelCommon.toTimestamp(value);
	}

	setHasSeenNoticeAt(value) {
		this.hasSeenNoticeAt = ModelCommon.toTimestamp(value);
	}

	setRecentLoginVersion(value) {
		this.recentLoginVersion = ModelCommon.toText(value, false);
	}

	setAuthId(value) {
		this.authId = ModelCommon.toText(value, false);
	}

	setIsAdditionalInfoComplete(value) {
		this.isAdditionalInfoComplete = ModelCommon.toSafeValue(value);
	}

	setEmail(value) {
		this.email = ModelCommon.toText(value, false);
	}

	setSocialUid(value) {
		this.socialUid = ModelCommon.toText(value, false);
	}

	setAccountId(value) {
		this.accountId = ModelCommon.toText(value, false);
	}

	setName(value) {
		this.name = ModelCommon.toText(value, false);
	}

	setNickname(value) {
		this.nickname = ModelCommon.toText(value, false);
	}

	setBirth(value) {
		this.birth = ModelCommon.toTimestamp(value);
	}

	setProfileImageUrl(value) {
		this.profileImageUrl = ModelCommon.toText(value, false);
	}

	setProfileImageBlurHash(value) {
		this.profileImageBlurHash = ModelCommon.toText(value, false);
	}

	setUserType(value) {
		this.userType = ModelCommon.toSafeValue(value);
	}

	setMembershipType(value) {
		this.membershipType = ModelCommon.toSafeValue(value);
	}

	setSignUpMethod(value) {
		this.signUpMethod = ModelCommon.toSafeValue(value);
	}

	setPoint(value) {
		this.point = ModelCommon.toNumber(value, false);
	}

	setMyInvitationLink(value) {
		this.myInvitationLink = ModelCommon.toText(value, false);
	}

	setAllowMarketing(value) {
		this.allowMarketing = ModelCommon.toSafeValue(value);
	}

	setPushToken(value) {
		this.pushToken = ModelCommon.toText(value, false);
	}

	setUnreadChatCountByRoomId(value) {
		this.unreadChatCountByRoomId = ModelCommon.toMap(value, true);
	}

	setBlockIds(value) {
		this.blockIds = ModelCommon.toList(value, true);
	}

	setReportPostIds(value) {
		this.reportPostIds = ModelCommon.toList(value, true);
	}

	setReportCommentIds(value) {
		this.reportCommentIds = ModelCommon.toList(value, true);
	}

	setMyNotiKeywordList(value) {
		this.myNotiKeywordList = ModelCommon.toList(value, true);
	}

	setMyChatRoomList(value) {
		this.myChatRoomList = ModelCommon.toList(value, true);
	}

	setPushTopicList(value) {
		this.pushTopicList = ModelCommon.toList(value, true);
	}

	setGender(value) {
		this.gender = ModelCommon.toSafeValue(value);
	}

	setPhone(value) {
		this.phone = ModelCommon.toText(value, false);
	}

	setAllowActivityNotification(value) {
		this.allowActivityNotification = ModelCommon.toSafeValue(value);
	}

	setAllowChatNotification(value) {
		this.allowChatNotification = ModelCommon.toSafeValue(value);
	}

	setIsAdmin(value) {
		this.isAdmin = ModelCommon.toSafeValue(value);
	}

	setAdminRole(value) {
		this.adminRole = ModelCommon.toSafeValue(value);
	}

	setUserRoleId(value) {
		this.userRoleId = ModelCommon.toText(value, false);
	}

	setComent(value) {
		this.coment = ModelCommon.toText(value, false);
	}

	setAdminMemo(value) {
		this.adminMemo = ModelCommon.toText(value, false);
	}

	setAreas(value) {
		this.areas = ModelCommon.toList(value, true);
	}

	setLikeFindTechnicianIds(value) {
		this.likeFindTechnicianIds = ModelCommon.toList(value, true);
	}

	setLikeRequsetWorkIds(value) {
		this.likeRequsetWorkIds = ModelCommon.toList(value, true);
	}

	setLikeJobPostingTraineeIds(value) {
		this.likeJobPostingTraineeIds = ModelCommon.toList(value, true);
	}

	setLikeJobPostingIds(value) {
		this.likeJobPostingIds = ModelCommon.toList(value, true);
	}

	setIsChangeNickName(value) {
		this.isChangeNickName = ModelCommon.toSafeValue(value);
	}

	setSubscriptionId(value) {
		this.subscriptionId = ModelCommon.toText(value, false);
	}

	setSubscriptionEndAt(value) {
		this.subscriptionEndAt = ModelCommon.toTimestamp(value);
	}

	setIosSubscription(value) {
		this.iosSubscription = ModelCommon.toSafeValue(value);
	}

	setAllowJobOffer(value) {
		this.allowJobOffer = ModelCommon.toSafeValue(value);
	}

	setAllowRequestWork(value) {
		this.allowRequestWork = ModelCommon.toSafeValue(value);
	}

	setAllowReceiveWork(value) {
		this.allowReceiveWork = ModelCommon.toSafeValue(value);
	}

	setAllowapplyWork(value) {
		this.allowapplyWork = ModelCommon.toSafeValue(value);
	}

	setAllowJobPosting(value) {
		this.allowJobPosting = ModelCommon.toSafeValue(value);
	}

	setAllowinterview(value) {
		this.allowinterview = ModelCommon.toSafeValue(value);
	}

	setAllowAskAnswer(value) {
		this.allowAskAnswer = ModelCommon.toSafeValue(value);
	}

	setAllowMarket(value) {
		this.allowMarket = ModelCommon.toSafeValue(value);
	}

	setAllowCompanyNews(value) {
		this.allowCompanyNews = ModelCommon.toSafeValue(value);
	}

	setAllowWirePrice(value) {
		this.allowWirePrice = ModelCommon.toSafeValue(value);
	}

	setQuit(value) {
		this.quit = ModelCommon.toSafeValue(value);
	}

	setQuitPhone(value) {
		this.quitPhone = ModelCommon.toText(value, false);
	}

	setQuitEmail(value) {
		this.quitEmail = ModelCommon.toText(value, false);
	}

	setQuitAt(value) {
		this.quitAt = ModelCommon.toTimestamp(value);
	}

	setIsAdminSetSubscribeFree(value) {
		this.isAdminSetSubscribeFree = ModelCommon.toSafeValue(value);
	}

	setIsSubscribeFree(value) {
		this.isSubscribeFree = ModelCommon.toSafeValue(value);
	}

	setShowEndContentReqWork(value) {
		this.showEndContentReqWork = ModelCommon.toSafeValue(value);
	}

	setShowEndContentFindTech(value) {
		this.showEndContentFindTech = ModelCommon.toSafeValue(value);
	}

	setShowEndContentJobPosting(value) {
		this.showEndContentJobPosting = ModelCommon.toSafeValue(value);
	}

	setShowEndContentMarket(value) {
		this.showEndContentMarket = ModelCommon.toSafeValue(value);
	}

	setShowEndContentCompanyNews(value) {
		this.showEndContentCompanyNews = ModelCommon.toSafeValue(value);
	}

	setSubscriptionType(value) {
		this.subscriptionType = ModelCommon.toSafeValue(value);
	}

	setSubscriptionRemainingDays(value) {
		this.subscriptionRemainingDays = ModelCommon.toSafeValue(value);
	}

	setRecommenderNumber(value) {
		this.recommenderNumber = ModelCommon.toText(value, false);
	}

	setIsFreeSubscribe(value) {
		this.isFreeSubscribe = ModelCommon.toSafeValue(value);
	}

	setFreeSubscribeStartAt(value) {
		this.freeSubscribeStartAt = ModelCommon.toTimestamp(value);
	}

	setLanguageCode(value) {
		this.languageCode = ModelCommon.toText(value, false);
	}

	setIsBanned(value) {
		this.isBanned = ModelCommon.toSafeValue(value);
	}

	setUnreadCommunityCommentCount(value) {
		this.unreadCommunityCommentCount = ModelCommon.toNumber(value, true);
	}

	setQnaUnreadComments(value) {
		this.qnaUnreadComments = ModelCommon.toMap(value, true);
	}

	setLastSeenWirePriceId(value) {
		this.lastSeenWirePriceId = ModelCommon.toText(value, false);
	}

	setCountry(value) {
		this.country = ModelCommon.toText(value, false);
	}

	setLastCountry(value) {
		this.lastCountry = ModelCommon.toText(value, false);
	}

	setShowHomeBottomHint(value) {
		this.showHomeBottomHint = ModelCommon.toSafeValue(value);
	}

	setSignUpPlatform(value) {
		this.signUpPlatform = ModelCommon.toText(value, false);
	}

	setRecentLoginPlatform(value) {
		this.recentLoginPlatform = ModelCommon.toText(value, false);
	}

	static skeleton = () => {
		let model = {
			id: '',
			createAt: null,
			recentLoginAt: null,
			hasSeenNotificationAt: null,
			hasSeenNoticeAt: null,
			recentLoginVersion: null,
			authId: null,
			isAdditionalInfoComplete: false,
			email: null,
			socialUid: null,
			accountId: null,
			name: null,
			nickname: null,
			birth: null,
			profileImageUrl: null,
			profileImageBlurHash: null,
			userType: null,
			membershipType: null,
			signUpMethod: null,
			point: null,
			myInvitationLink: null,
			allowMarketing: null,
			pushToken: null,
			unreadChatCountByRoomId: {},
			blockIds: [],
			reportPostIds: [],
			reportCommentIds: [],
			myNotiKeywordList: [],
			myChatRoomList: [],
			pushTopicList: [],
			gender: null,
			phone: null,
			allowActivityNotification: false,
			allowChatNotification: false,
			isAdmin: false,
			adminRole: null,
			userRoleId: null,
			coment: null,
			adminMemo: null,
			areas: [],
			likeFindTechnicianIds: [],
			likeRequsetWorkIds: [],
			likeJobPostingTraineeIds: [],
			likeJobPostingIds: [],
			isChangeNickName: false,
			subscriptionId: null,
			subscriptionEndAt: null,
			iosSubscription: null,
			allowJobOffer: null,
			allowRequestWork: null,
			allowReceiveWork: null,
			allowapplyWork: null,
			allowJobPosting: null,
			allowinterview: null,
			allowAskAnswer: null,
			allowMarket: null,
			allowCompanyNews: null,
			allowWirePrice: null,
			quit: null,
			quitPhone: null,
			quitEmail: null,
			quitAt: null,
			isSubscribeFree: null,
			isAdminSetSubscribeFree: null,
			showEndContentReqWork: null,
			showEndContentFindTech: null,
			showEndContentJobPosting: null,
			showEndContentMarket: null,
			showEndContentCompanyNews: null,
			subscriptionType: null,
			subscriptionRemainingDays: null,
			recommenderNumber: null,
			isFreeSubscribe: null,
			freeSubscribeStartAt: null,
			languageCode: null,
			isBanned: false,
			unreadCommunityCommentCount: 0,
			qnaUnreadComments: {},
			lastSeenWirePriceId: null,
			country: null,
			lastCountry: null,
			showHomeBottomHint: null,
			signUpPlatform: null,
			recentLoginPlatform: null,
		}
		return new UserModel(model);
	}

	toJson = () => {
		return {
			id: this.id,
			createAt: this.createAt,
			recentLoginAt: this.recentLoginAt,
			hasSeenNotificationAt: this.hasSeenNotificationAt,
			hasSeenNoticeAt: this.hasSeenNoticeAt,
			recentLoginVersion: this.recentLoginVersion,
			authId: this.authId,
			isAdditionalInfoComplete: this.isAdditionalInfoComplete,
			email: this.email,
			socialUid: this.socialUid,
			accountId: this.accountId,
			name: this.name,
			nickname: this.nickname,
			birth: this.birth,
			profileImageUrl: this.profileImageUrl,
			profileImageBlurHash: this.profileImageBlurHash,
			userType: this.userType,
			membershipType: this.membershipType,
			signUpMethod: this.signUpMethod,
			point: this.point,
			myInvitationLink: this.myInvitationLink,
			allowMarketing: this.allowMarketing,
			pushToken: this.pushToken,
			unreadChatCountByRoomId: this.unreadChatCountByRoomId,
			blockIds: this.blockIds,
			reportPostIds: this.reportPostIds,
			reportCommentIds: this.reportCommentIds,
			myNotiKeywordList: this.myNotiKeywordList,
			myChatRoomList: this.myChatRoomList,
			pushTopicList: this.pushTopicList,
			gender: this.gender,
			phone: this.phone,
			allowActivityNotification: this.allowActivityNotification,
			allowChatNotification: this.allowChatNotification,
			isAdmin: this.isAdmin,
			adminRole: this.adminRole,
			userRoleId: this.userRoleId,
			coment: this.coment,
			adminMemo: this.adminMemo,
			areas: this.areas,
			likeFindTechnicianIds: this.likeFindTechnicianIds,
			likeRequsetWorkIds: this.likeRequsetWorkIds,
			likeJobPostingTraineeIds: this.likeJobPostingTraineeIds,
			likeJobPostingIds: this.likeJobPostingIds,
			isChangeNickName: this.isChangeNickName,
			subscriptionId: this.subscriptionId,
			subscriptionEndAt: this.subscriptionEndAt,
			iosSubscription: this.iosSubscription,
			allowJobOffer: this.allowJobOffer,
			allowRequestWork: this.allowRequestWork,
			allowReceiveWork: this.allowReceiveWork,
			allowapplyWork: this.allowapplyWork,
			allowJobPosting: this.allowJobPosting,
			allowinterview: this.allowinterview,
			allowAskAnswer: this.allowAskAnswer,
			allowMarket: this.allowMarket,
			allowCompanyNews: this.allowCompanyNews,
			allowWirePrice: this.allowWirePrice,
			quit: this.quit,
			quitPhone: this.quitPhone,
			quitEmail: this.quitEmail,
			quitAt: this.quitAt,
			isSubscribeFree: this.isSubscribeFree,
			isAdminSetSubscribeFree: this.isAdminSetSubscribeFree,
			showEndContentReqWork: this.showEndContentReqWork,
			showEndContentFindTech: this.showEndContentFindTech,
			showEndContentJobPosting: this.showEndContentJobPosting,
			showEndContentMarket: this.showEndContentMarket,
			showEndContentCompanyNews: this.showEndContentCompanyNews,
			subscriptionType: this.subscriptionType,
			subscriptionRemainingDays: this.subscriptionRemainingDays,
			recommenderNumber: this.recommenderNumber,
			isFreeSubscribe: this.isFreeSubscribe,
			freeSubscribeStartAt: this.freeSubscribeStartAt,
			languageCode: this.languageCode,
			isBanned: this.isBanned,
			unreadCommunityCommentCount: this.unreadCommunityCommentCount,
			qnaUnreadComments: this.qnaUnreadComments,
			lastSeenWirePriceId: this.lastSeenWirePriceId,
			country: this.country,
			lastCountry: this.lastCountry,
			showHomeBottomHint: this.showHomeBottomHint,
			signUpPlatform: this.signUpPlatform,
			recentLoginPlatform: this.recentLoginPlatform,
		};
	}

	toString = () => {
		return JSON.stringify(this.toJson());
	}
}

class UserDb {
	static currentTimestamp = () => {
		return firebase.firestore.Timestamp.now();
	}
	static dateToTimestamp = (date) => {
		return firebase.firestore.Timestamp.fromDate(new Date(date));
	}
	static timestampToDate = (timestamp) => {
		return ModelCommon.toTimestamp(timestamp).toDate();
	}
	static collectionRef = () => {
		return firebase.firestore()
			.collection("users");
	}
	static runTransaction = async (func) => {
		return await firebase.firestore().runTransaction(func);
	}
	static FieldValue = firebase.firestore.FieldValue;
	static loadAll = async (limit) => {
		let itemList = [];
		let ref = firebase.firestore()
			.collection('users');
		if (limit != null) {
			ref = ref.limit(limit);
		}
		await ref.orderBy('createAt', 'desc').get()
		.then(async (querySnapshot) => {
			for (let i = 0; i < querySnapshot.docs.length; i++) {
				let itemInfo = querySnapshot.docs[i].data();
				itemInfo.id = querySnapshot.docs[i].id;
				itemList.push(itemInfo);
			}
		});
		return itemList;
	}
	static load = async (id) => {
		let item = null;
		await firebase.firestore()
			.collection('users')
			.doc(id)
			.get()
			.then(async (documentSnapshot) => {
				if(documentSnapshot.exists) {
					item = documentSnapshot.data();
				}
			});
		return item;
	}
	static add = async (model) => {
		let newDocRef = firebase.firestore()
			.collection('users')
			.doc();
		let addModel = model;
		addModel.id = newDocRef.id;
		await newDocRef.set(addModel);
	}
	static update = async (id, model) => {
		await firebase.firestore()
			.collection('users')
			.doc(id)
			.update(model);
	}
	// 업체 삭제 시: 이 업체 id 를 userRoleId 로 가진 모든 유저의 userRoleId/userType 을 해제.
	// 단건 조회 없이 where 쿼리로 일괄 조회 후 writeBatch 로 일괄 업데이트. (writeBatch 500 제한 → 400개씩 커밋)
	static clearRoleByCompanyId = async (companyId) => {
		if (!companyId) return;
		const db = firebase.firestore();
		const snapshot = await db.collection('users').where('userRoleId', '==', companyId).get();
		const docs = snapshot.docs;
		for (let i = 0; i < docs.length; i += 400) {
			const batch = db.batch();
			docs.slice(i, i + 400).forEach((d) => {
				batch.update(d.ref, { userRoleId: null, userType: null });
			});
			await batch.commit();
		}
	}
	static updateOrder = async (models) => {
		if (models.length > 0) {
			let ref = firebase.firestore()
				.collection('users')
				.doc(models[0].id);
			await firebase.firestore().runTransaction((transaction) => {
				return transaction.get(ref).then(() => {
					for (let i = 0; i < models.length; i++) {
						let ref = firebase.firestore()
							.collection('users')
							.doc(models[i].id);
						transaction.update(ref, { order: models[i].order });
					}
				});
			});
		}
	}
	static delete = async (id) => {
		await firebase.firestore()
			.collection('users')
			.doc(id)
			.delete();
	}
	static set = async (id, model) => {
		await firebase.firestore()
			.collection('users')
			.doc(id)
			.set(model);
	}
	// 관리자(admin) auth 계정에 연결된 users 문서 보장.
	// 문서 id = auth uid 로 생성하고 authId 필드에도 동일 uid 저장(연결 규칙 두 가지 모두 충족), isAdmin=true.
	// 멱등: 이미 있으면 isAdmin 만 보장. 없으면 skeleton 기반으로 생성.
	static ensureAdminUser = async (uid, email) => {
		if (!uid) return;
		const ref = firebase.firestore().collection('users').doc(uid);
		const snap = await ref.get();
		const ADMIN_ROLE = 'AdminRole.superAdmin';
		if (snap.exists) {
			// 기존 문서엔 isAdmin / adminRole 누락분만 backfill
			const data = snap.data() || {};
			const patch = {};
			if (data.isAdmin !== true) patch.isAdmin = true;
			if (!data.adminRole) patch.adminRole = ADMIN_ROLE;
			if (Object.keys(patch).length > 0) await ref.update(patch);
			return;
		}
		const model = UserModel.skeleton();
		model.setId(uid);
		model.setAuthId(uid);
		model.setIsAdmin(true);
		model.setAdminRole(ADMIN_ROLE);
		model.setCreateAt(firebase.firestore.Timestamp.now());
		model.setName('관리자');
		if (email) model.setEmail(email);
		await ref.set(model.toJson());
	}
}

export { UserModel, UserDb };

// 1. 필드 추가
/*
const [createAt, setCreateAt] = React.useState(user.createAt);
const [recentLoginAt, setRecentLoginAt] = React.useState(user.recentLoginAt);
const [hasSeenNotificationAt, setHasSeenNotificationAt] = React.useState(user.hasSeenNotificationAt);
const [hasSeenNoticeAt, setHasSeenNoticeAt] = React.useState(user.hasSeenNoticeAt);
const [recentLoginVersion, setRecentLoginVersion] = React.useState(user.recentLoginVersion);
const [authId, setAuthId] = React.useState(user.authId);
const [isAdditionalInfoComplete, setIsAdditionalInfoComplete] = React.useState(user.isAdditionalInfoComplete);
const [email, setEmail] = React.useState(user.email);
const [socialUid, setSocialUid] = React.useState(user.socialUid);
const [accountId, setAccountId] = React.useState(user.accountId);
const [name, setName] = React.useState(user.name);
const [nickname, setNickname] = React.useState(user.nickname);
const [birth, setBirth] = React.useState(user.birth);
const [profileImageUrl, setProfileImageUrl] = React.useState(user.profileImageUrl);
const [profileImageBlurHash, setProfileImageBlurHash] = React.useState(user.profileImageBlurHash);
const [userType, setUserType] = React.useState(user.userType);
const [membershipType, setMembershipType] = React.useState(user.membershipType);
const [signUpMethod, setSignUpMethod] = React.useState(user.signUpMethod);
const [point, setPoint] = React.useState(user.point);
const [myInvitationLink, setMyInvitationLink] = React.useState(user.myInvitationLink);
const [allowMarketing, setAllowMarketing] = React.useState(user.allowMarketing);
const [pushToken, setPushToken] = React.useState(user.pushToken);
const [unreadChatCountByRoomId, setUnreadChatCountByRoomId] = React.useState(user.unreadChatCountByRoomId);
const [blockIds, setBlockIds] = React.useState(user.blockIds);
const [reportPostIds, setReportPostIds] = React.useState(user.reportPostIds);
const [reportCommentIds, setReportCommentIds] = React.useState(user.reportCommentIds);
const [myNotiKeywordList, setMyNotiKeywordList] = React.useState(user.myNotiKeywordList);
const [myChatRoomList, setMyChatRoomList] = React.useState(user.myChatRoomList);
const [pushTopicList, setPushTopicList] = React.useState(user.pushTopicList);
const [gender, setGender] = React.useState(user.gender);
const [phone, setPhone] = React.useState(user.phone);
const [allowActivityNotification, setAllowActivityNotification] = React.useState(user.allowActivityNotification);
const [allowChatNotification, setAllowChatNotification] = React.useState(user.allowChatNotification);
const [isAdmin, setIsAdmin] = React.useState(user.isAdmin);
const [userRoleId, setUserRoleId] = React.useState(user.userRoleId);
const [coment, setComent] = React.useState(user.coment);
const [areas, setAreas] = React.useState(user.areas);
const [likeFindTechnicianIds, setLikeFindTechnicianIds] = React.useState(user.likeFindTechnicianIds);
const [likeRequsetWorkIds, setLikeRequsetWorkIds] = React.useState(user.likeRequsetWorkIds);
const [likeJobPostingTraineeIds, setLikeJobPostingTraineeIds] = React.useState(user.likeJobPostingTraineeIds);
const [likeJobPostingIds, setLikeJobPostingIds] = React.useState(user.likeJobPostingIds);
const [isChangeNickName, setIsChangeNickName] = React.useState(user.isChangeNickName);
const [subscriptionId, setSubscriptionId] = React.useState(user.subscriptionId);
const [subscriptionEndAt, setSubscriptionEndAt] = React.useState(user.subscriptionEndAt);
const [iosSubscription, setIosSubscription] = React.useState(user.iosSubscription);
const [allowJobOffer, setAllowJobOffer] = React.useState(user.allowJobOffer);
const [allowRequestWork, setAllowRequestWork] = React.useState(user.allowRequestWork);
const [allowReceiveWork, setAllowReceiveWork] = React.useState(user.allowReceiveWork);
const [allowapplyWork, setAllowapplyWork] = React.useState(user.allowapplyWork);
const [allowJobPosting, setAllowJobPosting] = React.useState(user.allowJobPosting);
const [allowinterview, setAllowinterview] = React.useState(user.allowinterview);
const [allowAskAnswer, setAllowAskAnswer] = React.useState(user.allowAskAnswer);
const [allowTrainee, setAllowTrainee] = React.useState(user.allowTrainee);
const [allowMarket, setAllowMarket] = React.useState(user.allowMarket);
const [allowCompanyNews, setAllowCompanyNews] = React.useState(user.allowCompanyNews);
const [allowWirePrice, setAllowWirePrice] = React.useState(user.allowWirePrice);
const [quit, setQuit] = React.useState(user.quit);
const [quitPhone, setQuitPhone] = React.useState(user.quitPhone);
const [quitEmail, setQuitEmail] = React.useState(user.quitEmail);
const [quitAt, setQuitAt] = React.useState(user.quitAt);
const [isAdminSetSubscribeFree, setIsAdminSetSubscribeFree] = React.useState(user.isAdminSetSubscribeFree);
const [isSubscribeFree, setIsSubscribeFree] = React.useState(user.isSubscribeFree);
const [showEndContentReqWork, setShowEndContentReqWork] = React.useState(user.showEndContentReqWork);
const [showEndContentFindTech, setShowEndContentFindTech] = React.useState(user.showEndContentFindTech);
const [showEndContentJobPosting, setShowEndContentJobPosting] = React.useState(user.showEndContentJobPosting);
const [showEndContentMarket, setShowEndContentMarket] = React.useState(user.showEndContentMarket);
const [showEndContentCompanyNews, setShowEndContentCompanyNews] = React.useState(user.showEndContentCompanyNews);
const [subscriptionType, setSubscriptionType] = React.useState(user.subscriptionType);
const [subscriptionRemainingDays, setSubscriptionRemainingDays] = React.useState(user.subscriptionRemainingDays);
const [recommenderNumber, setRecommenderNumber] = React.useState(user.recommenderNumber);
const [isFreeSubscribe, setIsFreeSubscribe] = React.useState(user.isFreeSubscribe);
const [freeSubscribeStartAt, setFreeSubscribeStartAt] = React.useState(user.freeSubscribeStartAt);
const [languageCode, setLanguageCode] = React.useState(user.languageCode);
const [isBanned, setIsBanned] = React.useState(user.isBanned);
const [unreadCommunityCommentCount, setUnreadCommunityCommentCount] = React.useState(user.unreadCommunityCommentCount);
const [lastSeenWirePriceId, setLastSeenWirePriceId] = React.useState(user.lastSeenWirePriceId);
*/

// 2. 값 입력 부분 구현
/*
if (typeof recentLoginAt != 'undefined') {
	newItem.setRecentLoginAt(recentLoginAt);
}
if (typeof hasSeenNotificationAt != 'undefined') {
	newItem.setHasSeenNotificationAt(hasSeenNotificationAt);
}
if (typeof hasSeenNoticeAt != 'undefined') {
	newItem.setHasSeenNoticeAt(hasSeenNoticeAt);
}
if (typeof recentLoginVersion != 'undefined') {
	newItem.setRecentLoginVersion(recentLoginVersion);
}
if (typeof authId != 'undefined') {
	newItem.setAuthId(authId);
}
if (typeof isAdditionalInfoComplete != 'undefined') {
	newItem.setIsAdditionalInfoComplete(isAdditionalInfoComplete);
}
if (typeof email != 'undefined') {
	newItem.setEmail(email);
}
if (typeof socialUid != 'undefined') {
	newItem.setSocialUid(socialUid);
}
if (typeof accountId != 'undefined') {
	newItem.setAccountId(accountId);
}
if (typeof name != 'undefined') {
	newItem.setName(name);
}
if (typeof nickname != 'undefined') {
	newItem.setNickname(nickname);
}
if (typeof birth != 'undefined') {
	newItem.setBirth(birth);
}
if (typeof profileImageUrl != 'undefined') {
	newItem.setProfileImageUrl(profileImageUrl);
}
if (typeof profileImageBlurHash != 'undefined') {
	newItem.setProfileImageBlurHash(profileImageBlurHash);
}
if (typeof userType != 'undefined') {
	newItem.setUserType(userType);
}
if (typeof membershipType != 'undefined') {
	newItem.setMembershipType(membershipType);
}
if (typeof signUpMethod != 'undefined') {
	newItem.setSignUpMethod(signUpMethod);
}
if (typeof point != 'undefined') {
	newItem.setPoint(point);
}
if (typeof myInvitationLink != 'undefined') {
	newItem.setMyInvitationLink(myInvitationLink);
}
if (typeof allowMarketing != 'undefined') {
	newItem.setAllowMarketing(allowMarketing);
}
if (typeof pushToken != 'undefined') {
	newItem.setPushToken(pushToken);
}
if (typeof unreadChatCountByRoomId != 'undefined') {
	newItem.setUnreadChatCountByRoomId(unreadChatCountByRoomId);
}
if (typeof blockIds != 'undefined') {
	newItem.setBlockIds(blockIds);
}
if (typeof reportPostIds != 'undefined') {
	newItem.setReportPostIds(reportPostIds);
}
if (typeof reportCommentIds != 'undefined') {
	newItem.setReportCommentIds(reportCommentIds);
}
if (typeof myNotiKeywordList != 'undefined') {
	newItem.setMyNotiKeywordList(myNotiKeywordList);
}
if (typeof myChatRoomList != 'undefined') {
	newItem.setMyChatRoomList(myChatRoomList);
}
if (typeof pushTopicList != 'undefined') {
	newItem.setPushTopicList(pushTopicList);
}
if (typeof gender != 'undefined') {
	newItem.setGender(gender);
}
if (typeof phone != 'undefined') {
	newItem.setPhone(phone);
}
if (typeof allowActivityNotification != 'undefined') {
	newItem.setAllowActivityNotification(allowActivityNotification);
}
if (typeof allowChatNotification != 'undefined') {
	newItem.setAllowChatNotification(allowChatNotification);
}
if (typeof isAdmin != 'undefined') {
	newItem.setIsAdmin(isAdmin);
}
if (typeof userRoleId != 'undefined') {
	newItem.setUserRoleId(userRoleId);
}
if (typeof coment != 'undefined') {
	newItem.setComent(coment);
}
if (typeof areas != 'undefined') {
	newItem.setAreas(areas);
}
if (typeof likeFindTechnicianIds != 'undefined') {
	newItem.setLikeFindTechnicianIds(likeFindTechnicianIds);
}
if (typeof likeRequsetWorkIds != 'undefined') {
	newItem.setLikeRequsetWorkIds(likeRequsetWorkIds);
}
if (typeof likeJobPostingTraineeIds != 'undefined') {
	newItem.setLikeJobPostingTraineeIds(likeJobPostingTraineeIds);
}
if (typeof likeJobPostingIds != 'undefined') {
	newItem.setLikeJobPostingIds(likeJobPostingIds);
}
if (typeof isChangeNickName != 'undefined') {
	newItem.setIsChangeNickName(isChangeNickName);
}
if (typeof subscriptionId != 'undefined') {
	newItem.setSubscriptionId(subscriptionId);
}
if (typeof subscriptionEndAt != 'undefined') {
	newItem.setSubscriptionEndAt(subscriptionEndAt);
}
if (typeof iosSubscription != 'undefined') {
	newItem.setIosSubscription(iosSubscription);
}
if (typeof allowJobOffer != 'undefined') {
	newItem.setAllowJobOffer(allowJobOffer);
}
if (typeof allowRequestWork != 'undefined') {
	newItem.setAllowRequestWork(allowRequestWork);
}
if (typeof allowReceiveWork != 'undefined') {
	newItem.setAllowReceiveWork(allowReceiveWork);
}
if (typeof allowapplyWork != 'undefined') {
	newItem.setAllowapplyWork(allowapplyWork);
}
if (typeof allowJobPosting != 'undefined') {
	newItem.setAllowJobPosting(allowJobPosting);
}
if (typeof allowinterview != 'undefined') {
	newItem.setAllowinterview(allowinterview);
}
if (typeof allowAskAnswer != 'undefined') {
	newItem.setAllowAskAnswer(allowAskAnswer);
}
if (typeof allowTrainee != 'undefined') {
	newItem.setAllowTrainee(allowTrainee);
}
if (typeof allowMarket != 'undefined') {
	newItem.setAllowMarket(allowMarket);
}
if (typeof allowCompanyNews != 'undefined') {
	newItem.setAllowCompanyNews(allowCompanyNews);
}
if (typeof allowWirePrice != 'undefined') {
	newItem.setAllowWirePrice(allowWirePrice);
}
if (typeof quit != 'undefined') {
	newItem.setQuit(quit);
}
if (typeof quitPhone != 'undefined') {
	newItem.setQuitPhone(quitPhone);
}
if (typeof quitEmail != 'undefined') {
	newItem.setQuitEmail(quitEmail);
}
if (typeof quitAt != 'undefined') {
	newItem.setQuitAt(quitAt);
}
if (typeof isAdminSetSubscribeFree != 'undefined') {
	newItem.setIsAdminSetSubscribeFree(isAdminSetSubscribeFree);
}
if (typeof isSubscribeFree != 'undefined') {
	newItem.setIsSubscribeFree(isSubscribeFree);
}
if (typeof showEndContentReqWork != 'undefined') {
	newItem.setShowEndContentReqWork(showEndContentReqWork);
}
if (typeof showEndContentFindTech != 'undefined') {
	newItem.setShowEndContentFindTech(showEndContentFindTech);
}
if (typeof showEndContentJobPosting != 'undefined') {
	newItem.setShowEndContentJobPosting(showEndContentJobPosting);
}
if (typeof showEndContentMarket != 'undefined') {
	newItem.setShowEndContentMarket(showEndContentMarket);
}
if (typeof showEndContentCompanyNews != 'undefined') {
	newItem.setShowEndContentCompanyNews(showEndContentCompanyNews);
}
if (typeof subscriptionType != 'undefined') {
	newItem.setSubscriptionType(subscriptionType);
}
if (typeof subscriptionRemainingDays != 'undefined') {
	newItem.setSubscriptionRemainingDays(subscriptionRemainingDays);
}
if (typeof recommenderNumber != 'undefined') {
	newItem.setRecommenderNumber(recommenderNumber);
}
if (typeof isFreeSubscribe != 'undefined') {
	newItem.setIsFreeSubscribe(isFreeSubscribe);
}
if (typeof freeSubscribeStartAt != 'undefined') {
	newItem.setFreeSubscribeStartAt(freeSubscribeStartAt);
}
if (typeof languageCode != 'undefined') {
	newItem.setLanguageCode(languageCode);
}
if (typeof isBanned != 'undefined') {
	newItem.setIsBanned(isBanned);
}
if (typeof unreadCommunityCommentCount != 'undefined') {
	newItem.setUnreadCommunityCommentCount(unreadCommunityCommentCount);
}
if (typeof lastSeenWirePriceId != 'undefined') {
	newItem.setLastSeenWirePriceId(lastSeenWirePriceId);
}
*/
